export default function Logo({ className }) {
  return (
    <svg 
      className={className} 
      viewBox="0 0 100 100" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: "40px", height: "40px" }}
    >
      <path d="M20 20H80V40H40V60H80V80H20V20Z" fill="#0B1F3A" />
      <path d="M40 20H60V80H40V20Z" fill="#C9963E" />
    </svg>
  );
}
